


















































































































































































































































































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import {
  resumeListReq,
  resumeForm,
} from "@/common/class/resumeManagement/index";
import {
  getResumeList,
  getState,
  getResumeDetail,
} from "@/api/resumeManagement/index";
import myLoading from "@/components/global/my-loading/index.vue";

interface nameTest {
  majorDescribe: string;
}
@Component({
  components: {
    myLoading,
  },
})
export default class empowermentQueryComponent extends Vue {
  isRequest = false;
  req = new resumeListReq();
  resumeForm = new resumeForm();
  tableloading = false;
  tableData = new DataParse();
  Height = 250;
  resultList = [];
  resumeDialogVisible = false;
  resumeDialogloading = false;

  created() {
    this.getList();
    this.getStateList();
  }

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight, false);
  }

  getHeight() {
    //获取浏览器高度并计算得到表格所用高度。
    this.$nextTick(() => {
      this.Height = document.documentElement.clientHeight - 180;
    });
  }

  // 查询
  onSubmit() {
    this.req.pageNo = 1;
    this.getList();
  }

  // 重置
  reSubmit() {
    this.req = new resumeListReq();
    this.getList();
  }
  // 预览文件
  fileView(val: any) {
    let url = val;
    window.open(
      `${process.env.VUE_APP_FILE_ONLINE_ADDRESS}?url=${url}`,
      "_blank"
    );
    // window.open(``, "_blank");
  }

  // 获取列表
  getList() {
    this.tableloading = true;
    getResumeList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }
  //获取简历状态
  getStateList() {
    getState({})
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.resultList = data;
        }
      })
      .finally(() => {});
  }
  //获取简历详情
  resumeDetail(id: any) {
    this.resumeDialogVisible = true;
    this.resumeDialogloading = true;
    let param = { resId: id };
    getResumeDetail(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.resumeForm = data;
        }
      })
      .finally(() => {
        this.resumeDialogloading = false;
      });
  }
  changePage(index: number) {
    this.req.pageNo = index;
    this.getList();
  }
}
